<template>
  <a-card :bordered="false">
    <search-page-view
      ref="pageList"
      :itemNames="['search-name','add-button']"
      :query-params="queryParams"
      :request-promise="getRequestPromise"
      :enable-search="false"
      :columns="getColumns()"
    >
      <a-form-item slot="search-name" label="券码名称" v-bind="searchItemLayout">
        <a-input-search placeholder="请输入券码名称" v-model="queryParams.couponName"
                        @search="onSearchEvent"></a-input-search>
      </a-form-item>
      <a-form-item slot="add-button">
        <a-button type="primary" @click="addEvent" style="margin-left: 10px">+ 新建</a-button>
      </a-form-item>
      <span slot="number" slot-scope="rowItem">
        {{ rowItem.record.usedNum }}/{{ rowItem.record.stockNum }}
      </span>
      <template slot="action" slot-scope="rowItem">
        <a @click="toDetail(rowItem.record)">查看</a>
        <template v-if="rowItem.record.couponStatus==0">
          <a-divider type="vertical"></a-divider>
          <a @click="toEditor(rowItem.record)">编辑</a>
        </template>
        <a-divider type="vertical"></a-divider>
        <a @click="toCodeDetailList(rowItem.record)">查看券码</a>
        <template v-if="rowItem.record.type==='DZM'">
          <a-divider type="vertical"></a-divider>
          <a @click="toVerification(rowItem.record)">核销设置</a>
        </template>
        <template v-if="rowItem.record.type==='DHQ'||rowItem.record.type==='JHM'">
          <a-divider type="vertical"></a-divider>
          <a @click="toSetting(rowItem.record)">预约设置</a>
        </template>
        <template v-if="rowItem.record.useFlag === 0">
          <a-divider type="vertical"></a-divider>
          <a-popconfirm
            title="确认删除此条数据吗?"
            @confirm="toDelete(rowItem.record.id)">
            <a>删除</a>
          </a-popconfirm>
        </template>
      </template>
    </search-page-view>
  </a-card>

</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'CouponCodeList',
  mixins: [searchForm],
  data() {
    return {
      queryParams: {}
    }
  },

  mounted() {
  },
  methods: {
    toDelete(id) {
      this.getHttpServices().getCouponService()
        .post('couponSetInfo/delete', { id: id })
        .then(res => {
          this.$message.success('删除成功')
          this.$refs.pageList.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getRequestPromise(params) {
      return this.getHttpServices().getCouponService().post('couponSetInfo/selectCouponSetInfoList', params)
    },
    onSearchEvent() {
      this.$refs.pageList.refresh(true)
    },
    addEvent() {
      this.openNewPage('CouponCodeCreator', {})
    },
    //查看详情
    toDetail(record) {
      this.openNewPage('CouponCodeDetail', { id: record.id })
    },
    toEditor(record) {
      this.openNewPage('CouponCodeEditor', { id: record.id })
    },
    //券码（查看）
    toCodeDetailList(record) {
      let { id, type, name } = record
      this.openNewPage('CodeDetailList', { id, type, name })
    },
    //核销设置
    toVerification(record) {
      console.error('==record===', record)
      this.openNewPage('VerificationSetting', {
        proId: record.id,
        couponId: record.id,
        proName: record.name
      })
    },
    //（预约）设置
    toSetting(record) {
      const params = {
        proId: record.proId,
        couponType: record.type
      }
      this.openNewPage('CouponCodeSetting', params)
    },
    getColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'id',
          width: '60px'
        },
        {
          title: '券码名称',
          dataIndex: 'name',
          width: '22%'
        },
        {
          title: '券码类型',
          dataIndex: 'typeStr'
        },
        {
          title: '使用方式',
          dataIndex: 'useWayStr'
        },
        {
          title: '数量',
          dataIndex: 'number',
          scopedSlots: { customRender: 'number' }
        },
        {
          title: '状态',
          dataIndex: 'couponStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '300px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }

}
</script>
<style scoped>
</style>